/** Where the "Powered by" credit sends people. */
export const ED_WEBSITE = 'https://equestrian.digital';

/**
 * The ED monogram, inlined from apps/ed-usa assets rather than linked.
 *
 * Inlining keeps it a single request and lets the mark take its color from the
 * surrounding text: the tile paints in `currentColor` and the letterforms are
 * knocked out in the page ground, so the credit and its logo darken together on
 * hover without a second asset for each state.
 */
export function EdLogo() {
  return (
    <svg class="ed-logo" viewBox="0 0 108.3 108.3" aria-hidden="true" focusable="false">
      <rect width="108.3" height="108.3" rx="6" fill="currentColor" />
      <path
        fill="var(--bg)"
        d="M46,32.9h14.8c3,0,5.6,0.3,7.9,1c2.3,0.7,4.2,1.6,5.9,2.7c1.7,1.1,3,2.5,4.1,3.9c1.1,1.5,2,3,2.6,4.6c0.6,1.6,1.1,3.1,1.4,4.7c0.3,1.6,0.4,3,0.4,4.3c0,2.7-0.5,5.4-1.5,7.9c-1,2.5-2.5,4.8-4.4,6.8c-2,2-4.4,3.6-7.3,4.8c-2.9,1.2-6.2,1.8-10,1.8H46V32.9z M51.7,70H59c2.4,0,4.7-0.3,6.9-1c2.2-0.7,4.1-1.7,5.7-3c1.6-1.3,2.9-3,3.9-4.9c1-2,1.4-4.3,1.4-6.9c0-1.4-0.2-2.9-0.7-4.8c-0.4-1.8-1.3-3.5-2.5-5.2c-1.2-1.6-2.9-3-5.1-4.2c-2.2-1.1-5-1.7-8.4-1.7h-8.6V70z"
      />
      <path
        fill="var(--bg)"
        d="M53.7,75.4H25.2V70H48V56.4H27.8V51H48V38.3H26.3v-5.4h27.4V75.4z"
      />
    </svg>
  );
}

/**
 * `loading` holds the message back for a moment: a Firestore read usually lands
 * first, and a "Loading…" line that flashes for a frame reads as a glitch.
 */
export function Placeholder({ message, tone }: { message: string; tone?: 'error' | 'loading' }) {
  return (
    <div class={tone ? `placeholder placeholder--${tone}` : 'placeholder'} role="status">
      {message}
    </div>
  );
}

/**
 * The "Powered by" credit.
 *
 * The embed runs in a sandboxed frame, so this needs `allow-popups` on the
 * iframe in embed.js to open at all, and `noopener` so the opened tab cannot
 * reach back into the frame.
 */
export function Credit() {
  return (
    <a class="credit" href={ED_WEBSITE} target="_blank" rel="noopener noreferrer">
      <EdLogo />
      <span>Powered by Equestrian Digital</span>
    </a>
  );
}
